
import React from 'react'
import Relationships from 'shared_src/dictionaries/demographics/Insurance'

import {
  bindTargetMixin,
  CancelButton,
  MaskedTextInput,
  RadioGroupInput,
  SaveButton,
  TextInput,
  DateInput,
  SelectInput
} from '../../../../../shared/FormBuilder'
import { Paper } from '../../../../../shared/NarusMaterial'
import { SystemManaged } from '../../../../../shared/SystemManaged'

class InsuranceForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  getValue () {
    return { ...this.state.value }
  }

  componentDidMount () {
    const {
      value: { relationship }
    } = this.state

    if (!relationship) {
      this.setState(state => ({
        ...state,
        value: {
          ...state.value,
          relationship: 'self'
        }
      }))
    }
  }

  handleSubmit () {
    const { onSubmit } = this.props
    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  render () {
    const disableSave = !this.state.value.provider
    return (
      <div className='margin-top margin-bottom'>
        <Paper>
          {this.state.value.isSystemManaged
            ? (
              <div className='row end-xs'>
                <SystemManaged />
              </div>
            )
            : null}
          <input
            type='hidden'
            name='id'
          />
          <input
            type='hidden'
            name='isSystemManaged'
          />
          <div className='row middle-xs'>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Carrier Name'
                name='provider'
                disabled={this.state.value.isSystemManaged}
                required
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Plan'
                name='plan'
                disabled={this.state.value.isSystemManaged}
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Group #'
                name='groupNumber'
                disabled={this.state.value.isSystemManaged}
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Member Id'
                name='memberId'
                disabled={this.state.value.isSystemManaged}
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Subscriber Name'
                name='subscriberName'
                disabled={this.state.value.isSystemManaged}
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Subscriber ID'
                name='subscriberNumber'
                disabled={this.state.value.isSystemManaged}
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Dependent Id'
                name='dependentId'
                disabled={this.state.value.isSystemManaged}
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <SelectInput
                label='Relationship'
                name='relationship'
                options={Relationships}
                disabled={this.state.value.isSystemManaged}
                required
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4 '>
              <MaskedTextInput
                name='phoneNumber'
                label='Phone Number'
                mask='111.111.1111'
                phone
              />
            </div>
            <div className='col-xs-12 col-sm-6'>
              <DateInput
                label='Eligibility Start'
                name='eligibilityStart'
                disabled={this.state.value.isSystemManaged}
              />
            </div>
            <div className='col-xs-12 col-sm-6'>
              <DateInput
                label='Eligibility End'
                name='eligibilityEnd'
                disabled={this.state.value.isSystemManaged}
              />
            </div>
            <div
              className='col-xs-offset-1 col-xs-11'
              style={{
                paddingTop: '15px',
                paddingBottom: '15px'
              }}
            >
              <RadioGroupInput
                name='primaryOrSecondary'
                options={[
                  {
                    label: 'Primary',
                    value: 'primary'
                  },
                  {
                    label: 'Secondary',
                    value: 'secondary'
                  }
                ]}
              />
            </div>
          </div>

          <div className='row margin-top end-xs'>
            <div className='col-xs-12'>
              <CancelButton
                noGlobal
                onClick={this.props.onCancel}
              />
              <SaveButton
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </div>
    )
  }
}

export default InsuranceForm
